import { render } from "./TvmBbTradeValue.vue?vue&type=template&id=b88fc7fc&scoped=true"
import script from "./TvmBbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmBbTradeValue.vue?vue&type=script&lang=js"

import "./TvmBbTradeValue.vue?vue&type=style&index=0&id=b88fc7fc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88fc7fc"],['__file',"src/components/ChatWidget/TvmSellUsYourCar/TvmBbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b88fc7fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b88fc7fc', __exports__)) {
    api.reload('b88fc7fc', __exports__)
  }
  
  module.hot.accept("./TvmBbTradeValue.vue?vue&type=template&id=b88fc7fc&scoped=true", () => {
    api.rerender('b88fc7fc', render)
  })

}


export default __exports__